export const SET_AUTH_DATA = 'SET_AUTH_DATA';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_REGISTER_USER_MESSAGE = 'SET_REGISTER_USER_MESSAGE';
